import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Flex, Spacer, StyleProps, Text } from '@bonusly/design-system';

import { useFeedbackContext } from '../context/feedback-context';
import { ActionMenu } from './action-menu';
import { CompleteBadge } from './complete-badge';
import { HeaderTooltip } from './header-tooltip';
import { useHeaderText } from './hooks/use-header-text';
import { PendingBadge } from './pending-badge';
import { VisibilityBadge } from './visibility-badge';
import { VisibilityToggle } from './visibility-toggle';

interface EvaluationHeaderProps extends StyleProps {
	isNew?: boolean;
	showName?: boolean;
}

export const EvaluationHeader: FC<EvaluationHeaderProps> = ({ isNew = false, ...rest }) => {
	const { t } = useTranslation('feedback');
	const { giver_name, key, receiver_name } = useHeaderText();
	const { editEvaluation } = useFeedbackContext();

	return (
		<Flex bg="bg.canvas" borderRadius="md" p={3} {...rest}>
			<Text fontWeight="semibold">
				<Trans
					i18nKey={`request.${key}`}
					count={0}
					t={t}
					values={{
						name: receiver_name,
						names: [giver_name],
					}}
				>
					Bruce Banner
					<Text as="span" fontWeight="normal">
						asked
					</Text>
					<HeaderTooltip isDisabled={false} names={[giver_name]}>
						Iron Man and Thor
					</HeaderTooltip>
				</Trans>
			</Text>
			<Spacer />

			<CompleteBadge isNew={isNew} />
			<PendingBadge />
			<VisibilityBadge />
			<VisibilityToggle />
			{editEvaluation != undefined && <ActionMenu ml={2} />}
		</Flex>
	);
};
